/**
 * 기능 플래그 상수
 * 환경 변수를 통해 기능의 활성화/비활성화를 제어합니다.
 */

/**
 * add1(ID) 중복 표시 기능 활성화 여부
 * .env 파일에 REACT_APP_SHOW_ADD1_DUPLICATE=true 설정 시 활성화됩니다.
 * 기본값: false (비활성화)
 */
export const SHOW_ADD1_DUPLICATE =
  process.env.REACT_APP_SHOW_ADD1_DUPLICATE === 'true' || process.env.REACT_APP_SHOW_ADD1_DUPLICATE === '1';


